import React, { useEffect, useState, } from 'react'
import { Modal } from 'react-bootstrap'
import HtmlParser from 'react-html-parser';

import axios from 'axios';
import moment from 'moment';

import {
    responseGet, globalSettings, separatorsNumbersSet, styles, validateDecimals, sendMessageCloseCurrentWindowAsync, numberSet, dateTimeFormatGlobalSet, languageObjGet,
    isUndNullEmp, isUndNull, isNumber, awaitDelay,
} from '../../helpers/settings';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { bankAccountMovementModelGet } from '../../models/bankAccounts/bankAccountMovement';

const currentMethod = 'BankAccountMovementAddEditDetails';

const neutralValue = 0.00;
const neutralValueStr = separatorsNumbersSet({
    number: neutralValue,
    withDecimals: true,
    consoleLogErrorShow: true,
    subMethod: currentMethod,
})?.result;
const { icons, labels, messages, } = globalSettings;
const { tempusDominus, } = globalSettings?.react;
const { backend } = globalSettings?.app;

export default function BankAccountMovementAddEditDetails({
    $ = {},
    auth = {},
    bankAccountMovement = bankAccountMovementModelGet({}),
    setMovement = () => { },
    processType = 0,
    btnMovementSearchId = '',
    showModal = false,
    setShowModal = () => { },
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const movementDateId = 'movementDateId';
    const [movementDateError, setMovementDateError] = useState('');
    const [movementTypeError, setMovementTypeError] = useState('');
    const [movementAmountError, setMovementAmountError] = useState('');
    const [movementReferenceError, setMovementReferenceError] = useState('');
    const [movementRemarkError, setMovementRemarkError] = useState('');
    //#endregion variables

    //#region others
    const controls = {
        buttons: {
            save: {
                id: 'btnBankAccountMovementModalSave',
                className: 'btn btn-outline-primary mx-1',
                classNameTwo: 'btn btn-outline-warning mx-1',
            },
            back: {
                id: 'btnBankAccountMovementModalBack',
                className: 'btn btn-outline-success',
            },
            close: {
                id: 'btnBankAccountMovementModalClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        dataTables: {
            // movements: {
            //     buttons: {
            //         // detailAdd: {
            //         //     className: 'btn btn-sm btn-outline-info mx-1 float-right',
            //         //     id: 'btnDtPurchaseDetailsIdDetailAdd',
            //         // },
            //     },
            //     icons: {
            //         // detailAdd: {
            //         //     id: 'iconDtPurchaseDetailsIdDetailAdd',
            //         //     className: icons?.list,
            //         // },
            //     },
            //     inputs: {
            //         search: {
            //             id: `${dtMovementsId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtMovementsId}_length select`,
            //             className: '',
            //         },
            //     },
            //     // spinners: {
            //     //     detailAdd: {
            //     //         id: 'spDtPurchaseDetailsIdDetailAdd',
            //     //         className: '',
            //     //     },
            //     // },
            // },
        },
        icons: {
            save: {
                id: 'icoBankAccountMovementModalSave',
                className: icons?.save,
            },
            back: {
                id: 'icoBankAccountMovementModalBack',
                className: icons?.arrowCircleLeft,
            },
            close: {
                id: 'icoBankAccountMovementModalClose',
                className: '',
            },
        },
        inputs: {
            date: {
                id: 'inputBankAccountMovementModalDate',
                className: 'form-control datetimepicker-input',
            },
            amount: {
                id: 'inputBankAccountMovementModalAmount',
                className: 'form-control text-right',
            },
            reference: {
                id: 'inputBankAccountMovementModalReference',
                className: 'form-control',
            },
            remark: {
                id: 'inputBankAccountMovementModalRemark',
                className: 'form-control',
            },
        },
        radioButtons: {
            // all: {
            //     id: 'rButonAll',
            //     className: 'icheck-primary d-inline',
            //     name: 'radioButtonName',
            // },
        },
        selects: {
            type: {
                id: 'selBankAccountMovementModalType',
                className: 'form-select',
            },
        },
        spinners: {
            save: {
                id: 'spBankAccountMovementModalSave',
                className: '',
            },
            back: {
                id: 'spBankAccountMovementModalBack',
                className: '',
            },
            close: {
                id: 'spBankAccountMovementModalClose',
                className: '',
            },
        },
    };
    //#endregion others

    //#region methods
    const defaultValueSetAsync = async ({
        isModalClose = false,
        subMethod = '',
    }) => {
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }

            setShowModal(!isModalClose);
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const saveChangeAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'saveChangeAsync';
        let response = responseGet();
        try {
            //#region initialize
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }
            //#endregion initialize

            //#region data set
            response = await dataSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion data set

            //#region errors default set
            response = await errosDefaultSetAsync({
                subMethod: '',
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion errors default set

            //#region form data validate
            response = await validateFormDataAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion form data vakidate

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region create / edit movement
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                bankAccountMovement: bankAccountMovement,
                languageCode: languageObj?.code,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlBankAccountMovements}/`,
            };

            switch (processType) {
                case 0:
                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj,
                    );
                    break;
                case 1:
                    dataObj.url = `${dataObj?.url}${bankAccountMovement.id}`;
                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj,
                    );
                    break;
                default:
                    break;
            }

            response = result.data;
            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion create / edit movement

            await defaultValueSetAsync({
                isModalClose: true,
                subMethod: currentMethod,
            });

            $(`#${btnMovementSearchId}`)?.trigger('click');

            sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataSetAsync';
        let response = responseGet();
        try {
            const dateTimeObj = {
                date: $(`#${movementDateId}`)?.datetimepicker('date')?._d,
            };
            bankAccountMovement.date = dateTimeObj?.date || bankAccountMovement?.date;
            bankAccountMovement.amount = numberSet({
                number: bankAccountMovement?.amount,
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dateInControlSetAsync = async ({
        date = new Date(),
        movementDate = {},
        subMethod = '',
    }) => {
        const currentMethod = 'dateInControlSetAsync';
        let response = responseGet();
        try {
            //#region variables
            const dateTimeObj = {
                date: '',
                time: 0,
                format: languageObj?.format?.date?.f1,
                formatTwo: languageObj?.format?.date?.f11,
            };
            //#endregion variables

            //#region methods
            if (!isUndNullEmp({ data: movementDate, subMethod: currentMethod, })?.result) {
                dateTimeObj.date = dateTimeFormatGlobalSet({
                    date: movementDate,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else {
                dateTimeObj.date = dateTimeFormatGlobalSet({
                    date: date,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                icons: tempusDominus?.icons,
                buttons: tempusDominus?.buttons,
                tooltips: tempusDominus?.tooltips,
                locale: languageObj?.id,
            });

            $(`#${movementDateId}`)?.datetimepicker({
                date: moment(dateTimeObj?.date, dateTimeObj?.formatTwo),
                default: false,
                timepicker: false,
                format: dateTimeObj?.formatTwo,
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region dateTime in control sets
            response = dateInControlSetAsync({
                date: new Date(),
                movementDate: processType === 0 ? {} : bankAccountMovement?.date,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion dateTime in control sets
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const errosDefaultSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'errosDefaultSetAsync';
        let response = responseGet();
        try {
            setMovementTypeError('');
            setMovementDateError('');
            setMovementRemarkError('');
            setMovementAmountError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const validateFormDataAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'validateFormDataAsync';
        let response = responseGet();
        try {
            //#region variables
            const dateTimeObj = {
                date: $(`#${controls?.inputs?.date?.id}`)?.val(),
            };
            //#endregion variables

            //#region methods
            if (isUndNullEmp({ data: dateTimeObj?.date, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: bankAccountMovement?.date, subMethod: currentMethod, })?.result) {
                setMovementDateError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: bankAccountMovement?.remark, subMethod: currentMethod, })?.result) {
                setMovementRemarkError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: bankAccountMovement?.type, subMethod: currentMethod, })?.result) {
                setMovementTypeError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: bankAccountMovement?.reference, subMethod: currentMethod, })?.result) {
                setMovementReferenceError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNull({ data: bankAccountMovement?.amount, subMethod: currentMethod, })?.result) {
                setMovementAmountError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (bankAccountMovement?.amount <= neutralValue || !isNumber({ number: bankAccountMovement?.amount, languageId: languageObj?.id, subMethod: currentMethod, })?.result) {
                setMovementAmountError(`${labels?.amount?.[languageObj?.id]}. ${messages?.mustBeGreaterThan?.[languageObj?.id]} <b>${neutralValueStr}</b>`);
                response.isWarning = true;
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.date?.id}`).attr({ readOnly: (processType !== 0), });
            $(`#${controls?.selects?.type?.id}`).attr({ disabled: (processType !== 0), });
            $(`#${controls?.inputs?.reference?.id}`).attr({ readOnly: (processType !== 0), });
            $(`#${controls?.inputs?.amount?.id}`).attr({ readOnly: (processType !== 0), });
            $(`#${controls?.inputs?.remark?.id}`).attr({ readOnly: (processType !== 0), });
            //#endregion controls

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            // $(`#${controls?.dataTables?.movements?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.dataTables?.movements?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({
            subMethod: 'form - onLoad',
        });
    }, [showModal]); //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal backdrop='static' onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })} show={showModal}>
            <Modal.Header>
                <Modal.Title>
                    <img alt='bankAccountMovement'
                        style={styles?.cardHeaderLogo}
                        src={globalSettings?.images?.movementsLogo}></img> - {labels?.movement?.[languageObj?.id]} ({processType === 0 ? labels?.add?.[languageObj?.id]?.toLowerCase() : (processType === 1 ? labels?.edit?.[languageObj?.id]?.toLowerCase() : labels?.detail?.[languageObj?.id]?.toLowerCase())})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => saveChangeAsync({ e: e, subMethod: 'form - onSubmit', })}>
                <Modal.Body>
                    {/* <div className='card shadow-lg'> */}

                    {/* <div className='card-body'> */}
                    {processType === 0 || processType === 1 ?
                        <div>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <div id={movementDateId} className='input-group date'
                                                data-target-input='nearest'>
                                                <input id={controls?.inputs?.date?.id}
                                                    className={controls?.inputs?.date?.className}
                                                    data-target={`#${movementDateId}`}
                                                    data-toggle='datetimepicker'
                                                    onFocus={() => setMovementDateError('')}
                                                    placeholder={labels?.date?.[languageObj?.id]}
                                                    tooltip='tooltip'
                                                    title={labels?.date?.[languageObj?.id]}
                                                    type='text' />
                                                <div className='input-group-append' data-target={`#${movementDateId}`} data-toggle='datetimepicker'>
                                                    <div className='input-group-text'><i className={icons?.calendarAlt}></i></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(movementDateError)}</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <select id={controls?.selects?.type?.id}
                                                className={controls?.selects?.type?.className}
                                                defaultValue={bankAccountMovement?.subType || ''}
                                                onChange={(e) => setMovement({
                                                    ...bankAccountMovement,
                                                    subType: e?.target?.value,
                                                    type: e?.target?.options[e?.target?.options?.selectedIndex]?.getAttribute('about'),
                                                })}
                                                onFocus={() => setMovementTypeError('')}
                                                tooltip='tooltip'
                                                title={labels?.buildings?.[languageObj?.id]}>
                                                <option key='nothing' value=''>{messages?.selectType?.[languageObj?.id]}</option>
                                                {globalSettings.bank.transactionTypes?.map((detail) => (
                                                    <option about={detail?.type} key={detail?.id} value={detail?.id}>{detail?.description?.[languageObj?.id]}</option>
                                                ))}
                                            </select>
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className='fas fa-sort' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(movementTypeError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.reference?.id}
                                                className={controls?.inputs?.reference?.className}
                                                onChange={(e) => setMovement({
                                                    ...bankAccountMovement,
                                                    reference: e?.target?.value,
                                                })}
                                                onFocus={() => setMovementReferenceError('')}
                                                placeholder={labels?.reference?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.reference?.[languageObj?.id]}
                                                value={bankAccountMovement.reference || ''} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.spellCheck} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(movementReferenceError)}</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.amount?.id}
                                                className={controls?.inputs?.amount?.className}
                                                onChange={(e) => setMovement({
                                                    ...bankAccountMovement,
                                                    amount: validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - amount', })
                                                })}
                                                onFocus={() => setMovementAmountError('')}
                                                placeholder={labels?.amount?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.amount?.[languageObj?.id]}
                                                value={bankAccountMovement?.amount || '0.00'} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.moneyBillWave} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(movementAmountError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <textarea id={controls?.inputs?.remark?.id}
                                                className={controls?.inputs?.remark?.className}
                                                placeholder={labels?.remark?.[languageObj?.id]}
                                                onChange={(e) => setMovement({
                                                    ...bankAccountMovement,
                                                    remark: e?.target?.value,
                                                })}
                                                onFocus={() => setMovementRemarkError('')}
                                                value={bankAccountMovement.remark || ''}
                                                tooltip='tooltip'
                                                title={labels?.remark?.[languageObj?.id]}>
                                            </textarea>
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.edit} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(movementRemarkError)}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <></>
                    }
                    {/* <div>
                                <div className='row text-muted'>
                                    <div className='col-md-4'>
                                        {labels?.type?.[languageObj?.id]}:
                                    </div>
                                    <div className='col-md-8'>
                                        <b>{movementTypeDescription}</b>
                                    </div>
                                </div>

                                <div className='row text-muted'>
                                    <div className='col-md-4'>
                                        {labels?.date?.[languageObj?.id]}:
                                    </div>
                                    <div className='col-md-8'>
                                        <b>{movementDate} </b>
                                    </div>
                                </div>

                                <div className='row text-muted'>
                                    <div className='col-md-4'>
                                        {labels?.reference?.[languageObj?.id]}:
                                    </div>
                                    <div className='col-md-8'>
                                        <b>{!isUndefined(movement.result.reference) ? movement.result.reference : ''}</b>
                                    </div>
                                </div>

                                <div className='row text-muted'>
                                    <div className='col-md-4'>
                                        {labels?.amount?.[languageObj?.id]}:
                                    </div>
                                    <div className='col-md-8'>
                                        <b>{!isUndefined(movement.result.amount) ? separatorsNumbersSet(movement.result.amount) : 0.00}</b>
                                    </div>
                                </div>

                                <hr/>

                                <div className='row text-muted'>
                                    <div className='col-md-4'>
                                        {labels?.origin?.[languageObj?.id]}:
                                    </div>
                                    <div className='col-md-8'>
                                        <b>{movementOrigin} </b>
                                    </div>
                                </div>

                                <div className='row text-muted'>
                                    <div className='col-md-4'>
                                    {labels?.identifier?.[languageObj?.id]}:
                                    </div>
                                    <div className='col-md-8'>
                                        <b>{movementOriginNumber} </b>
                                    </div>
                                </div>

                                <div className='row text-muted'>
                                    <div className='col-md-4'>
                                        {movementType === 1 ? labels?.receipt?.[languageObj?.id] : (movementType === -1 ? labels?.number?.[languageObj?.id] : '')}:
                                    </div>
                                    <div className='col-md-8'>
                                        <b>{movementOriginDocument} </b>
                                    </div>
                                </div>

                                <hr/>
                                
                            </div> */}

                    {/* <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.user?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{userConcilation}</b>
                                </div>
                            </div> */}
                    {/* </div> */}

                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                <button className={processType === 0 ? 'btn btn-outline-primary mx-1' : 'btn btn-outline-warning mx-1'}
                                    tooltip='tooltip'
                                    title={labels?.save?.[languageObj?.id]}
                                    type='submit'
                                    onClick={(e) => saveChangeAsync(e)}
                                    hidden={processType !== 0 && processType !== 1}>
                                    <i className={icons?.save}></i>
                                </button>
                                <button className='btn btn-outline-success'
                                    tooltip='tooltip'
                                    title={labels?.close?.[languageObj?.id]}
                                    type='button'
                                    onClick={() => defaultValueSetAsync(true)}>
                                    <i className={icons?.arrowAltCircleLeft}></i>
                                </button>
                            </div>
                        </div> */}
                    {/* </div> */}
                </Modal.Body>
                <Modal.Footer>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={processType === 0 ? controls?.buttons?.save?.className : controls?.buttons?.save?.classNameTwo}
                            tooltip='tooltip'
                            title={labels?.save?.[languageObj?.id]}
                            type='submit'
                            hidden={processType !== 0 && processType !== 1}>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='button'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnBack', })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}